import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Check, Star, Crown } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  return <section id="compra" className="py-8 px-4 bg-gradient-to-b from-amber-50/60 to-purple-50/40" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        <div className="text-center mb-6" data-id="element-134">
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-1" data-id="element-135">
            🌟 OFERTA ESPECIAL DE LANZAMIENTO
          </h2>
          <p className="text-lg text-gray-600" data-id="element-136">
            Elegí el plan que mejor se adapte a tu familia
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-start" data-id="element-137">
          {/* PLAN BASE */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden border-2 border-gray-200 relative" data-id="element-138">
            <div className="bg-gray-100 py-3 text-center" data-id="element-139">
              <div className="flex items-center justify-center gap-2" data-id="element-140">
                <Star className="w-5 h-5 text-gray-600" data-id="element-141" />
                <span className="font-bold text-gray-700 uppercase tracking-wide text-sm" data-id="element-142">
                  Plan Base
                </span>
              </div>
            </div>

            <div className="p-5 text-center" data-id="element-143">
              <p className="text-gray-400 font-bold uppercase tracking-widest text-xs mb-2" data-id="element-144">
                VALOR REAL{' '}
                <span className="line-through text-red-400" data-id="element-145">$49.990</span>
              </p>

              <div className="mb-4" data-id="element-146">
                <p className="text-red-600 font-bold text-sm mb-1" data-id="element-147">
                  🔥 HOY SOLO:
                </p>
                <div className="flex items-center justify-center gap-1" data-id="element-148">
                  <span className="text-lg text-gray-400 font-medium" data-id="element-149">ARS</span>
                  <span className="text-5xl font-black text-gray-900" data-id="element-150">
                    19.990
                  </span>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-151">
                  (pagas en la moneda de tu país)
                </p>
              </div>

              <div className="space-y-2 text-left text-sm mb-5" data-id="element-152">
                <div className="flex items-center gap-2" data-id="element-153">
                  <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-154" />
                  <span data-id="element-155">6 Tomos Digitales Guiados</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-156">
                  <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-157" />
                  <span data-id="element-158">3 Bonos exclusivos</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-159">
                  <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-160" />
                  <span data-id="element-161">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-162">
                  <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-163" />
                  <span data-id="element-164">Un solo pago</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-165">
                  <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-166" />
                  <span data-id="element-167">Acceso de por vida</span>
                </div>
              </div>

              <CTAButton text="👉 QUIERO EL PLAN BASE" subtext="Compra segura - Entrega inmediata" href="https://checkout.recursostop.shop/products/megapack-creando-recuerdos?variant=45816753488068:1" data-id="element-168" />
            </div>
          </div>

          {/* PLAN PREMIUM */}
          <motion.div initial={{
          scale: 1
        }} animate={{
          scale: [1, 1.01, 1]
        }} transition={{
          duration: 3,
          repeat: Infinity
        }} className="bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-yellow-400 relative" data-id="element-169">
            <div className="absolute top-0 right-0 bg-red-600 text-white text-xs font-bold px-3 py-1 rounded-bl-lg z-10" data-id="element-170">
              MÁS ELEGIDO
            </div>

            <div className="bg-gradient-to-r from-yellow-400 to-amber-400 py-3 text-center" data-id="element-171">
              <div className="flex items-center justify-center gap-2" data-id="element-172">
                <Crown className="w-5 h-5 text-amber-800" data-id="element-173" />
                <span className="font-black text-amber-900 uppercase tracking-wide text-sm" data-id="element-174">
                  Plan Premium
                </span>
              </div>
            </div>

            <div className="p-5 text-center" data-id="element-175">
              <p className="text-gray-400 font-bold uppercase tracking-widest text-xs mb-2" data-id="element-176">
                VALOR REAL{' '}
                <span className="line-through text-red-400" data-id="element-177">$79.990</span>
              </p>

              <div className="mb-4" data-id="element-178">
                <p className="text-red-600 font-bold text-sm mb-1" data-id="element-179">
                  🔥 HOY SOLO:
                </p>
                <div className="flex items-center justify-center gap-1" data-id="element-180">
                  <span className="text-lg text-gray-400 font-medium" data-id="element-181">ARS</span>
                  <span className="text-5xl font-black text-gray-900" data-id="element-182">
                    29.990
                  </span>
                </div>
                <p className="text-xs text-gray-500 mt-1" data-id="element-183">
                  (pagas en la moneda de tu país)
                </p>
              </div>

              <div className="space-y-2 text-left text-sm mb-5" data-id="element-184">
                <div className="flex items-center gap-2" data-id="element-185">
                  <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-186" />
                  <span className="font-semibold" data-id="element-187">Todo lo del Plan Base +</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-188">
                  <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-189" />
                  <span data-id="element-190">6 Tomos Digitales Guiados</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-191">
                  <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-192" />
                  <span data-id="element-193">3 Bonos exclusivos</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-194">
                  <Check className="w-4 h-4 text-yellow-500 shrink-0" data-id="element-195" />
                  <span className="font-semibold" data-id="element-196">
                    Contenido Premium exclusivo
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-197">
                  <Check className="w-4 h-4 text-yellow-500 shrink-0" data-id="element-198" />
                  <span className="font-semibold" data-id="element-199">
                    Actualizaciones de por vida
                  </span>
                </div>
                <div className="flex items-center gap-2" data-id="element-200">
                  <Check className="w-4 h-4 text-yellow-500 shrink-0" data-id="element-201" />
                  <span className="font-semibold" data-id="element-202">Soporte prioritario</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-203">
                  <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-204" />
                  <span data-id="element-205">Acceso inmediato</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-206">
                  <Check className="w-4 h-4 text-green-500 shrink-0" data-id="element-207" />
                  <span data-id="element-208">Acceso de por vida</span>
                </div>
              </div>

              <CTAButton text="👉 QUIERO EL PLAN PREMIUM" subtext="La mejor inversión para tu familia" href="https://checkout.recursostop.shop/products/megapack-creando-recuerdos?variant=45816753520836:1" className="!bg-amber-500 !hover:bg-amber-600 !border-amber-700" data-id="element-209" />
            </div>
          </motion.div>
        </div>

        {/* Mercado Pago + Garantía */}
        <div className="mt-6 text-center" data-id="element-210">
          <div className="flex flex-col items-center gap-2 mb-4" data-id="element-211">
            <img src="https://imgmp.mlstatic.com/org-img/banners/ar/medios/online/468X60.jpg" alt="Mercado Pago - Medios de pago" className="max-w-xs w-full rounded" data-id="element-212" />
            <div className="flex items-center gap-2 text-sm text-gray-500" data-id="element-213">
              <ShieldCheck className="w-4 h-4 text-blue-500" data-id="element-214" />
              <span data-id="element-215">
                Compra protegida por{' '}
                <strong className="text-blue-600" data-id="element-216">Mercado Pago</strong>
              </span>
            </div>
          </div>

          <div className="pt-4 border-t border-gray-200" data-id="element-217">
            <div className="flex flex-col items-center gap-2" data-id="element-218">
              <ShieldCheck className="w-10 h-10 text-gray-400" data-id="element-219" />
              <div data-id="element-220">
                <h4 className="font-bold text-gray-900" data-id="element-221">
                  🔒 Garantía sin riesgo
                </h4>
                <p className="text-gray-600 text-sm max-w-md mx-auto mt-1" data-id="element-222">
                  Probalo durante 7 días. Si sentís que no es para vos, te
                  devolvemos el 100% de tu dinero.
                  <br data-id="element-223" />
                  <span className="font-medium" data-id="element-224">Sin preguntas. Sin culpa.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}